import { useAppSelector } from 'redux/reduxHooks';

export const useIsInsuranceApplicable = (): boolean => {
  const {
    bookingFormSlice: {
      step3: { patientInfo, isPayForMyself, currentInsurance },
    },
    clinicDetailsSlice: { clinicData },
  } = useAppSelector((state) => state);

  if (!clinicData.isInsuranceEnabled) {
    return false;
  }

  return (
    !isPayForMyself &&
    currentInsurance?.id !==
      patientInfo?.insuranceCoverages?.[0]?.clinicInsuranceId
  );
};
